import { Switch as NextSwitch } from '@nextui-org/react';
import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const DESKTOP_WIDTH = '1.6875rem';
const DESKTOP_HEIGHT = '0.9375rem';
const MOBILE_WIDTH = '2.625rem';
const MOBILE_HEIGHT = '1.5rem';
const DESKTOP_CIRCLE_SIZE = '0.8125rem';
const MOBILE_CIRCLE_SIZE = '1.25rem';

export const StyledSwitch = styled(NextSwitch).attrs((props) => {
  return {
    ...props,
    css: {
      ...props.css,
      '&.nextui-switch-checked': {
        background: `${props.theme.gradients.button.default} !important`,
      },
    },
  };
})`
  padding: 0;
  height: ${DESKTOP_HEIGHT};
  max-width: ${DESKTOP_WIDTH} !important;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    min-width: ${MOBILE_WIDTH};
    height: ${MOBILE_HEIGHT};
  }

  .nextui-switch-checked {
    background: ${(props: ThemeProp) => props.theme.gradients.button.default} !important;
  }

  .nextui-switch--unchecked {
    background: ${(props: ThemeProp) => props.theme.colors.neutrals.c200} !important;
  }

  .nextui-switch {
    height: ${DESKTOP_HEIGHT};
    width: ${DESKTOP_WIDTH};
    justify-content: center;

    @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
      width: ${MOBILE_WIDTH};
      height: ${MOBILE_HEIGHT};
    }
  }

  .nextui-switch-circle {
    position: absolute;
    top: 1px;
    left: -1px;
    width: ${DESKTOP_CIRCLE_SIZE};
    height: ${DESKTOP_CIRCLE_SIZE};
    transition: all 0.1s ease-in;

    @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
      width: ${MOBILE_CIRCLE_SIZE};
      height: ${MOBILE_CIRCLE_SIZE};
      top: 2px;
      left: 0;
    }
  }

  .nextui-switch-checked {
    background: ${(props: ThemeProp) => props.theme.gradients.button.default} !important;
    .nextui-switch-circle {
      transform: translateX(0.8625rem) !important;
    }
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    .nextui-switch-checked {
      background: ${(props: ThemeProp) => props.theme.gradients.button.default} !important;
      .nextui-switch-circle {
        transform: translateX(1.25rem) !important;
      }
    }
  }
`;

export const Title = styled.div`
  color: ${(props: ThemeProp) => props.theme.colors.white};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  margin: auto auto auto 0.5rem;
`;

export const Description = styled.div`
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c400};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.xs};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-style: normal;
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.xs};
`;
